import styled from 'styled-components'

import { SidebarButtonUnstyled } from 'Components/Sidebar/SidebarButton/unstyled'

export const SidebarButton = styled(SidebarButtonUnstyled)`
  display: block;
  position: relative;
  width: 100%;
  background: transparent;
  text-decoration: none;
  color: ${props => props.theme.colors.white};
  opacity: 0.5;
  line-height: 54px;
  height: 54px;
  font-size: ${props => props.theme.fontSizes.sidebar.desktop};
  padding-right: 68px;
  padding-left: 20px;
  white-space: nowrap;
  &:hover,
  &.active {
    text-decoration: none;
    color: ${props => props.theme.colors.white};
    opacity: 1;
  }

  &:hover:before,
  &.active:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    background: ${props => props.theme.colors.primary};
    width: 4px;
    height: 100%;
  }

  .icon {
    display: inline-block;
    position: absolute;
    height: 54px;
    width: 24px;
    right: 25px;

    svg {
      display: inline-block;
      position: absolute;
      fill: ${props => props.theme.colors.white};
      margin: auto;
      left: 0;
      right: 0;
      top: 50%;
      height: 100%;
      width: ${props => (props.width ? props.width : '24px')};
      transform: translateY(-50%);
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Sidebar/SidebarButton/index.js